/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {continuousDeploymentSlackMessage} from '../api'

export const useMutationContinuousDeploymentSlackMessage = createReactQueryMutationHook('continuousDeploymentSlackMessage', continuousDeploymentSlackMessage)
